import moment from 'moment';
import React, { useState, useEffect } from 'react'
import { Line } from 'react-chartjs-2';
import { Maximize2 } from 'lucide-react';
import { useTranslation } from "react-i18next";

import { Card, Button } from "react-bootstrap";
import { getSensorDepths } from '../../utils/sensorDepths';

const SubSoilHumidityChart = ({ data, title, onSelect, sensorDepths }) => {

  const { t } = useTranslation();

  const [state, setState] = useState(null)
  const depths = getSensorDepths(sensorDepths)

  const getChartData = () => {

    let labels = []
    let dataMv1 = []
    let dataMv2 = []
    let dataMv3 = []

    data.map(sensorData => {
      const dateTime = moment(sensorData.time); // use the full timestamp
      const hour = dateTime.format('MMM Do HH:00'); // format date as "MMM Do HH:00"
      dataMv1.push(parseFloat(sensorData.mv1).toFixed(2))
      dataMv2.push(parseFloat(sensorData.mv2).toFixed(2))
      dataMv3.push(parseFloat(sensorData.mv3).toFixed(2))
      labels.push(hour);

    })

    labels.reverse();
    dataMv1.reverse();
    dataMv2.reverse();
    dataMv3.reverse();

    const state = {
      labels: labels,
      datasets: [
        {
          label: `Humidity ${depths.mv1} cm`,
          lineTension: 0.5,
          borderWidth: 2,
          data: dataMv1,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "#FC5566",
        },
        {
          label: `Humidity ${depths.mv2} cm`,
          lineTension: 0.5,
          borderWidth: 2,
          data: dataMv2,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "#3CB371",
        },
        {
          label: `Humidity ${depths.mv3} cm`,
          lineTension: 0.5,
          borderWidth: 2,
          data: dataMv3,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "#1E90FF",
        }
      ]
    }
    setState(state)
  }

  useEffect(() => {
    getChartData()
  }, [data, depths.mv1, depths.mv2, depths.mv3])

  const hasData = state && state.labels && state.labels.length > 0;

  return (
    <Card className="h-100">
      <Card.Header className="border-bottom d-flex justify-content-between">
        {title}
        <Button onClick={() => onSelect("SubSoilHumidityChart")} variant="light" aria-label={t("expand_chart", { defaultValue: "Expand chart" })}>
          <Maximize2 size={20} aria-hidden="true" />
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {hasData ? <Line
          data={state}
          options={{
            plugins: {
              title: {
                display: true,
                text: 'Subsoil Humidity (%)',
                fontSize: 15
              },
              legend: {
                display: true,
                position: 'bottom'
              },
            },

            scales: {
              y: {

                beginAtZero: true,
                min: 0

              }
            },
          }}
        /> : (
          <p className="text-center text-muted p-4">
            {t("no_data", { defaultValue: "No sensor history found for this period." })}
          </p>
        )}
      </Card.Body>
    </Card>
  );
}

export default SubSoilHumidityChart
